"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PromotionsNotification;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _utils = require("@whitbread-eos/utils");
var _nextI18next = require("next-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function PromotionsNotification() {
  var {
    t
  } = (0, _nextI18next.useTranslation)();
  var {
    showPromotionsNotification
  } = (0, _utils.usePromotionsNotification)() || {};
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: showPromotionsNotification && (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({
      "data-testid": "promotions-notification-banner"
    }, promotionsNotificationStyles), {}, {
      children: t('promotion.srp.notification')
    }))
  });
}
var promotionsNotificationStyles = {
  bgColor: 'tertiary',
  w: {
    mobile: 'full',
    xs: '22.375rem',
    sm: '16.25rem',
    md: '54rem'
  },
  m: 'var(--chakra-space-lg) auto',
  padding: 'md',
  borderRadius: 'var(--chakra-space-sm)',
  color: 'baseWhite',
  fontWeight: 'bold',
  fontSize: 'var(--chakra-fontSizes-md)',
  textAlign: 'center',
  mx: 'auto'
};